<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-11 11:24:06
-->
<template>
    <!-- :disabled="status === 'pending' || status === 'approved'" -->
  <el-upload
    drag
    :id="id"
    ref="upload"
    :before-upload="beforeUpload"
    action="default"
    :disabled="status === 'pending' || status === 'approved' || changeObj.show==='approve'"
    :http-request="upload"
    :headers="uploadHeaders"
    :show-file-list="false"
    :list-type="type==='img'?'picture':'text'"
    :file-list="fileList"
    :before-remove='remove'
    :on-success="handleAvatarSuccess"
    :on-error="uploadError"
    :class="{'has-active': hasDragged, 'has-upload-wrapper': hasUploadFile}"
  >
    <div class="upload-controller" v-if="!hasUploadFile">
      <img class="icon" :src="icon" alt="icon">
      <div class="slot-upload">拖拽{{type | fomateTypeToUpcase}} 到这里或<span class="upload-txt" slot="trigger">选择文件</span></div>
    </div>
    <div class="has-upload" v-if="hasUploadFile">
      <img class="icon" :src="activeIcon" alt="icon">
      <span v-if="changeObj && changeObj.show" :style="{color: changeObj.show === 'reject' ? '#F04037' : '#68BF7B'}">{{changeObj.txt}}</span>
      <span class="content-flex-1">{{name}}</span>
      <span v-if="deleteable" @click.stop="deleteHandler" class="delete-text">删除</span>
      <span v-if="couldDownload" @click.stop="downloadHandler" class="delete-text">下载</span>
      <span v-if="couldPreview" @click.stop="previewHandler" class="delete-text">在线预览</span>
    </div>
    <slot></slot>
    <div class="progress-control" v-if="uploading">
      <div class="progress">
        <div class="progress-inner" :style='{width: progressPerset}'></div>
      </div>
      <i class="el-icon-close" @click.stop="removeFile"></i>
    </div>
  </el-upload>
</template>
<script>
import axios from 'axios'
import { uploadFile } from '@/service/contestantInfo.js'
import eventBus from '../events'
import { event } from '../../main'
import { descriptionIsVideo, descriptionIsRethink } from '@/model/processingData'
import isSafeFileName from '@/model/fileValitor.js'

import auditStatus from '@/model/auditStatus'
export default {
  name: 'uploadImage',
  props: ['tag', 'type', 'img', 'index', 'name', 'path', 'activityId', 'playerId', 'fileDesc', 'deleteable', 'icon', 'activeIcon', 'couldDownload', 'changeObj', 'couldPreview'],
  data () {
    return {
      complete: 0,
      uploadHeaders: {
        'Authentication-Token': localStorage.getItem('auth_token')
      },
      fileList: [],
      fileSize: 0,
      fileStatusText: '被驳回',
      uploading: false,
      cancelToken: '',
      id: 'upload_' + Math.random().toString(36).substr(2),
      hasDragged: false
    }
  },
  computed: {
    hasUploadFile () {
      return this.name !== '' && this.name !== 'undefined'
    },
    status () {
      return this.$store.getters.getMaterialsStatus
    },
    progressPerset () {
      return this.complete + '%'
    }
  },
  filters: {
    fomateTypeToUpcase (type) {
      return type && type.toLocaleUpperCase()
    }
  },
  watch: {
    'name': {
      immediate: true,
      handler: function () {
        if (this.name) {
          let obj = {}
          if (this.type === 'pdf') {
            obj.url = this.path
            obj.name = this.name
          } else {
            obj.url = this.path.url
            obj.name = this.name
          }
          this.fileList = [obj]
        }
      },
      deep: true
    },
    fileDesc (val) {
      this.desc = val
    },
    deleteable (val) {
      this.desc = val
    },
    icon (val) {
      console.log(val)
    }
  },
  created () {
    if (!this.name) {
      event.$on('clearUploadList', () => {
        this.$refs['upload'].clearFiles()
      })
    }
  },
  mounted () {
    eventBus.$on('removeFile', (tag) => {
      if (this.tag === tag) {
        this.remove()
      }
    })
    const uploadDom = document.getElementById(this.id)
    uploadDom.addEventListener('dragover', () => {
      if (this.hasDragged) {
        return
      }
      this.hasDragged = true
    }, true)
    uploadDom.addEventListener('dragleave', () => {
      if (!this.hasDragged) {
        return
      }
      this.hasDragged = false
    }, true)
    uploadDom.addEventListener('drop', () => {
      if (!this.hasDragged) {
        return
      }
      this.hasDragged = false
    }, true)
  },
  methods: {
    deleteHandler () {
      this.$emit('deleteFile')
    },
    downloadHandler () {
      this.$emit('download')
    },
    previewHandler () {
      this.$emit('preview')
    },
    uploadError () {
      this.uploading = false
    },
    removeFile () {
      this.complete = 0
      this.cancelToken.cancel('cancel-manual')
      this.$refs.upload.clearFiles()
      this.uploading = false
    },
    // 覆盖默认上传行为
    upload (item) {
      this.complete = 0
      this.uploading = true
      this.fileSize = item.file.size
      let params = {}
      params.upload_type = 'material'
      params.activity_id = String(this.activityId)
      params.player_id = String(this.playerId)
      uploadFile(params).then(res => {
        this.host = res.data.host
        let params = {
          host: res.data.host
        }
        let fd = new FormData()
        fd.append('callback', res.data.callback)
        fd.append('success_action_status', '200')
        fd.append('OSSAccessKeyId', res.data.accessid)
        fd.append('policy', res.data.policy)
        fd.append('signature', res.data.signature)
        fd.append('key', `${res.data.dir}${item.file.name}`)
        fd.append('host', this.host)
        fd.append('x:activity_id', String(this.activityId))
        fd.append('x:user_id', String(this.playerId))
        fd.append('file', item.file)
        fd.append('expire', res.data.expire)
        fd.append('name', `${item.file.name}`)
        params['fd'] = fd
        this.complete = 0
        this.cancelToken = axios.CancelToken.source()
        axios.post(params.host, params.fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          cancelToken: this.cancelToken.token,
          onUploadProgress: progressEvent => {
            let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
            console.log(complete, '====sdsd=========')
            this.complete = complete
            self.uploadMessage = '上传 ' + complete
          }
        }).then((res2) => {
          if (res2.data.status === 'OK') {
            this.res = res2.data.filename
            this.handleAvatarSuccess('res', item, [item], this.tag)
            this.fileStatusText = '已更新'
          } else {
            this.uploading = false
            this.$confirm(`上传失败`, '提示')
          }
        }).catch((error) => {
          this.uploading = false
          if (!error || error.message !== 'cancel-manual') {
            this.$confirm(`上传失败`, '提示')
          }
        })
      })
        .catch(() => {
          this.uploading = false
          this.$confirm(`上传失败`, '提示')
        })
    },
    verify (type, file, reg) {
      // 验证
      if (!reg.test(file.name)) {
        this.$confirm(`请选择${type}文件格式`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
    },
    uploadGetIndex (e) {
      this.index = e
    },
    beforeUpload (file) {
      if (this.uploading) {
        this.$alert('文件正在上传中，请勿重复上传。如需更换文件，请待本次上传完成后，点击删除并重新上传。', '温馨提示', { confirmButtonText: '知道了', dangerouslyUseHTMLString: true })
        return false
      }
      const fileIsSafeResult = isSafeFileName(file.name)
      if (fileIsSafeResult) {
        this.$confirm(`文件名不能包含 ${fileIsSafeResult} 字符`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
      // 上传之前做后缀验证
      if (this.fileDesc && descriptionIsRethink(this.fileDesc)) { // 教学反思文件格式
        console.log('教学反思文件格式')
        let reg = /(?:.doc|.docx)$/
        return this.verify('Word', file, reg)
      }
      // 这里会先对desc进行判断，如果包含视频特定字符串则为视频格式，即使prop中传入的是mp4也是没有问题的。
      if (this.fileDesc && descriptionIsVideo(this.fileDesc)) { // 教学视频文件格式
        console.log('教学视频文件格式')
        let reg = /(?:.avi|.m4v|.mkv|.flv|.vob|.mp4|.3gp|.rm|.rmvb|.wmv|.asf|.asx|.MP4|.mpg|.mpeg|.mov)$/
        return this.verify('视频', file, reg)
      }
      if (this.type === 'pdf') {
        let reg = /(?:.pdf)$/
        return this.verify('pdf', file, reg)
      }
      if (this.type === 'ppt') {
        let reg = /(?:.ppt|.pptx)$/
        return this.verify('ppt', file, reg)
      }
      if (this.type === 'word') {
        let reg = /(?:.doc|.docx)$/
        return this.verify('Word', file, reg)
      }
      if (this.type === 'zip') {
        let reg = /(?:.zip)$/
        return this.verify('zip', file, reg)
      }
      if (this.type && (this.type.split(',')).length > 1) {
        let str = ''
        let regHandle = ''
        let arr = (this.type.split(','))
        arr.forEach((v, k) => {
          if (k + 1 === arr.length) {
            str = str + v
            regHandle = regHandle + '.' + v
          } else {
            str = str + v + '或'
            regHandle = regHandle + '.' + v + '|'
          }
        })
        let reg = /(?:.doc|.docx|.pdf)$/
        return this.verify(str, file, reg)
      }
    },
    remove () {
      this.fileList.pop()
      // 这里使用的是PersonInfo中的this.status
      let verifyStatus = this.$store.getters.getMaterialsStatus
      if (verifyStatus === auditStatus.PENDING) {
        this.$alert('信息审核中，请勿删除文件', '消息提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return false
      }
      if (verifyStatus === auditStatus.APPROVED) {
        this.$alert('信息已通过，不可删除文件', '消息提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return false
      }
      // this.$emit('uploadDel')
    },
    handleAvatarSuccess (res, file, fileList, tag) {
      this.uploading = false
      file.name = file.file.name
      file.index = fileList[0].index
      this.fileList = [file]
      this.$emit('uploadSucc', this.res, file.name, this.host, this.fileSize, tag)
    }
  }
}
</script>
<style scoped lang='scss'>
/deep/ .el-upload {
  width: 100%;
}

/deep/ .el-upload-dragger {
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding: 15px 10px;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  position: relative;
}

.has-active /deep/ .el-upload-dragger {
  border: 1px solid #C12B20;
  transform: scale(1.05);
}

.upload-controller {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-right: 20px;
}

.slot-upload {
  font-size: 16px;
  font-weight: 400;
  color: #BDC3D1;
  line-height: 20px;
  text-align: left;
}
.upload-txt {
  color: #F04037;
  font-weight: bold;
}

.delete-text {
  color: #F04037;
  margin-left: 20px;
  flex-shrink: 0;
}

.has-upload {
  color: #4E5A73;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}

.content-flex-1 {
  flex: 1;
  text-align: left;
  line-height: 20px;
}
.progress-control {
  width: 90%;
  position: absolute;
  left: 5%;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    flex-shrink: 0;
    font-size: 20px;
    font-weight: bold;
    color: #F04037;
  }
  .progress {
    height: 6px;
    border-radius: 4px;
    flex: 1;
    margin-right: 10px;
    background: #BDC3D1;
    overflow: hidden;
  }
  .progress-inner {
    background: #F04037;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload-view/index.vue